var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecoveryGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#e1e6ea;mix-blend-mode:multiply;}.cls-3,.cls-6,.cls-7{opacity:0.85;}.cls-3{fill:url(#linear-gradient);}.cls-4,.cls-9{fill:none;stroke:#3c4650;}.cls-4{stroke-miterlimit:10;}.cls-5{fill:#fff;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:#f05c2a;}.cls-9{stroke-linecap:round;stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 108.59,
    y1: 92.57,
    x2: 108.59,
    y2: 122.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 56.69,
    y1: 125.45,
    x2: 56.69,
    y2: 220.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 158.62,
    y1: 121.53,
    x2: 158.62,
    y2: 214.32,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "recovery_group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 108.95,
    cy: 70.5,
    r: 66.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.27,24.11l-.38-1.77a19.63,19.63,0,0,0-35.32,11.8V54.3A8.42,8.42,0,0,0,97,62.72s3.46-.85,4.39,0h0v2.67s-1.58,2-2.27,3h0a30.55,30.55,0,0,0-21,29v29.86l61.08,2V97.45a30.55,30.55,0,0,0-21.46-29.17h-.08a24,24,0,0,0-2.24-2.39V63.12a10.7,10.7,0,0,0,3.17-4.35v0c5.48,4.71,11.36-1.57,11.36-1.57-3,0-3-4.36-3-4.36V32.73a6,6,0,0,0-4.05-5.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 68.59,
    cy: 149.43,
    r: 66.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.71,68.09A66.57,66.57,0,0,0,107.14,1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.8,127.86a66.83,66.83,0,0,0,46.63,4.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.14,1.52a66.4,66.4,0,0,0-49.41,22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 149.3,
    cy: 149.43,
    r: 66.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.95,137.06A66.39,66.39,0,0,0,133,132.58a66.63,66.63,0,0,0-24.05-36.09,66.63,66.63,0,0,0-24.05,36.09A66.39,66.39,0,0,0,108.95,137.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.36,147a66.57,66.57,0,0,0-116-44.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.8,127.86a66.3,66.3,0,0,0,29.34,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.53,163.26h-.08c-.7-1-2.43-3-2.43-3v-1.83l0-.34a7.6,7.6,0,0,0,3-5.75s2.42-3,2.42-4.8V135.49l1.46-.47a3.1,3.1,0,0,0,2.51-4.93,3.09,3.09,0,0,0,1.23-4.76,3.07,3.07,0,0,0,.47-4.52,3.09,3.09,0,0,0-1.13-4.91A3.1,3.1,0,0,0,71.37,111h-.14a3.07,3.07,0,0,0-3.78-3.85s0-.08,0-.12a3.11,3.11,0,0,0-4.86-2.57A3.09,3.09,0,0,0,57.18,103a3.09,3.09,0,0,0-5.73.49,3.09,3.09,0,0,0-5.23,1.91,3.08,3.08,0,0,0-4.52,3.48,3,3,0,0,0-.53-.05A3.11,3.11,0,0,0,38.06,112a3.07,3.07,0,0,0,.3,1.31,3.09,3.09,0,0,0-2,5.38,3.09,3.09,0,0,0-.37,5.67,3.09,3.09,0,0,0,.84,5.63A3.08,3.08,0,0,0,39,135a3.1,3.1,0,0,0,2.54,4.89,3.05,3.05,0,0,0,.41,0,2.81,2.81,0,0,0,0,.33,3.1,3.1,0,0,0,2.31,3V147a13.19,13.19,0,0,0,4.61,10l0,.15v3.14s-1.71,2-2.46,3h0a33.08,33.08,0,0,0-22.79,31.44v.71S51,222.42,89.76,212.28V194.84A33.08,33.08,0,0,0,66.53,163.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.22,147a66.57,66.57,0,0,0,66.57,66.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175.76,157.77a18.3,18.3,0,0,0,4.12-8.33H180l-.12,0a18.42,18.42,0,0,0,.37-3.66V131.91a18.38,18.38,0,0,0-35.3-7.15l-.68,4.53a7.62,7.62,0,0,0-.77,0h-1.7a4.57,4.57,0,0,0-4.61,4.47,4.48,4.48,0,0,0,4.51,4.5l1.81.53v7A18.29,18.29,0,0,0,147.36,157l-.18-.06c0,.09,0,.17.05.26l-2,0a46.22,46.22,0,0,0-31.83,43.92l.08,4.51C124.2,212.9,137.16,216,151.11,216c21.89,0,40.58-12.06,52.71-28.37C203.82,187.63,198.11,163.85,175.76,157.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.06,147a66.57,66.57,0,0,0-116-44.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.93,147a66.57,66.57,0,0,0,66.57,66.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M101.39,122.54h.88c1.2,0,1.2-.73,1.2-1.5v-2.11h-3.27V121C100.19,121.84,100.19,122.54,101.39,122.54Zm-.07-2.51h1v1.4h-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "115.89 123.19 118.12 123.19 118.12 122.01 117.07 122.01 117.07 120.11 119.56 120.11 119.56 118.93 115.89 118.93 115.89 123.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.33,117v4c0,2.27,1,3.37,3,3.37h1.09c2,0,2.95-1.17,2.95-3.47v-.84H114V122h-1.13v1.18h2.31v-4.26h-11v2c0,1.9-.71,2.29-1.77,2.29h-1.09c-1.13,0-1.78-.36-1.78-2.19v-2.82h20.05V117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.69,42V53.43a10.69,10.69,0,1,0,21.38,0V32.78a10.69,10.69,0,0,0-6.53-9.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M113.51,52.67h-7.64c-3,0-1.37,3.14,1.2,3.14h5.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M110.93,48.9a2.4,2.4,0,1,0,0-4.8V35.63h5.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 110.93,
    y1: 38.64,
    x2: 114.15,
    y2: 38.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 102.78,
    y1: 38.64,
    x2: 107.2,
    y2: 38.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 111.46,
    y1: 52.67,
    x2: 111.46,
    y2: 55.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.32,48.13a1.7,1.7,0,0,0,0-3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.49,44.78a1.71,1.71,0,0,0-1.73,1.67,1.67,1.67,0,0,0,1.69,1.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.46,29.21a10.64,10.64,0,0,0,5.82-7.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.46,22.89a11.73,11.73,0,0,0-2.51.25c-5.15,1.12-6.66,5.8-7.64,10.21S99.84,42,96.69,42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M95.79,61.31a8.42,8.42,0,0,1-8.42-8.42V32.74a19.64,19.64,0,0,1,35.93-11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121.63,25.67a6,6,0,0,1,4.05,5.65V51.44s0,4.36,3,4.36c0,0-5.87,6.29-11.36,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.15,61.71v6.8s-3.7,15.64-7,15.64-7-15.64-7-15.64v-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M99,65.5a33.81,33.81,0,0,0-7,15.34s3.83-4.14,8.5-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M115.32,65.5a33.81,33.81,0,0,1,7,15.34s-3.83-4.14-8.5-4.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M116.46,66.88A30.55,30.55,0,0,1,137.92,96v8.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.84,96a30.55,30.55,0,0,1,21-29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.9,131.65v14.19a13.23,13.23,0,0,0,13.23,13.23c4.14,0,10.27-1.9,9.46-7.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M62.55,146.87H54.28c-3.56,0-.83,3.4,2.31,3.4h5.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.71,127.25H60.36v10.07a2.6,2.6,0,0,1,0,5.19h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M168.51,132.66v5.6a4,4,0,0,1,0,7.92h-4.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 60.36,
    y1: 129.91,
    x2: 63.85,
    y2: 129.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 159.96,
    y1: 135.28,
    x2: 162.64,
    y2: 135.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 172.05,
    y1: 135.28,
    x2: 174.73,
    y2: 135.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 49.19,
    y1: 129.91,
    x2: 53.98,
    y2: 129.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 60.33,
    y1: 146.87,
    x2: 60.33,
    y2: 150.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M170.52,151.53h-7.07c-3.23,0-1.48,2.8,1.3,2.8h5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 168.3,
    y1: 151.53,
    x2: 168.3,
    y2: 154.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.29,160.57a36.62,36.62,0,0,0-7.57,16.61s4.15-4.48,9.2-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M63.91,160.57a36.62,36.62,0,0,1,7.57,16.61s-4.15-4.48-9.2-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.15,162.06a33.09,33.09,0,0,1,23.24,31.58v11.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.25,193.64A33.08,33.08,0,0,1,45,162.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M174.33,156.56A46.33,46.33,0,0,1,201.94,185"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M112,199.85a46.22,46.22,0,0,1,31.83-43.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.43,130.69A2.52,2.52,0,0,0,49,133.21h5.26a2.52,2.52,0,0,0,2.52-2.52s0-1.8,2.69-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.68,133.21h5.26A2.52,2.52,0,0,0,68,132.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M56.74,127.31H42.66a4,4,0,0,0-4,3.91,3.92,3.92,0,0,0,3.94,3.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.08,130.09s6-.61,6,9c0,0,.1,9.18,11,9.18h19.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M140.58,137.54a3.72,3.72,0,0,1-3.74-3.74,3.79,3.79,0,0,1,3.83-3.71h1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.6,174.13S56.1,193,61,213.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.47,174.68s-8.65,14-10.83,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57.1,179.19c2.9-4.2,5.54-15.36,5.54-15.36v-6.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.49,156v7.79S50.14,175,53,179.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.06,191.77c-.61-4.46-2.32-6-2.32-6A9.81,9.81,0,0,0,58.22,180c-2.78-1.83-5.93,0-5.93,0a9.72,9.72,0,0,0,2,5.49s-1.91,3.26-1.71,5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.47,133.82A3.1,3.1,0,0,0,71,128.89a3.09,3.09,0,0,0,1.23-4.76,3.07,3.07,0,0,0,.47-4.52,3.09,3.09,0,0,0-1.13-4.91A3.1,3.1,0,0,0,69,109.82h-.14A3.07,3.07,0,0,0,65.07,106s0-.08,0-.12a3.11,3.11,0,0,0-4.86-2.57,3.09,3.09,0,0,0-5.42-1.46,3.09,3.09,0,0,0-5.73.5,3.09,3.09,0,0,0-5.23,1.91,3.07,3.07,0,0,0-1.52-.42,3.11,3.11,0,0,0-3.11,3.11,3,3,0,0,0,.11.79A3.09,3.09,0,0,0,36,112.09a3.09,3.09,0,0,0-2,5.38,3.09,3.09,0,0,0-.37,5.67,3.09,3.09,0,0,0,.84,5.63,3.08,3.08,0,0,0,2.19,5,3.1,3.1,0,0,0,2.54,4.89,3,3,0,0,0,.41,0,2.85,2.85,0,0,0,0,.33,3.11,3.11,0,0,0,2.31,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.73,114.1a12.74,12.74,0,0,1,7.78,11.73v21a11.2,11.2,0,0,1-.88,4.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.4,125.82c6.83,0,3.26-12.09,11.09-12.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M145.75,155.72a14.75,14.75,0,0,0,24.33,8.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 79.68,
    y1: 187.32,
    x2: 79.68,
    y2: 211.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 127.79,
    y1: 94.1,
    x2: 127.79,
    y2: 116.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 189.25,
    y1: 183.91,
    x2: 189.25,
    y2: 202.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 107.15,
    cy: 88.59,
    r: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 166.32,
    y1: 166.71,
    x2: 166.32,
    y2: 192.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 161.98,
    cy: 172.27,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 161.98,
    cy: 179.17,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 161.98,
    cy: 186.08,
    r: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175,155.76a18.28,18.28,0,0,0,3.83-11.22V130.71a18.38,18.38,0,0,0-35.3-7.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.08,133.25v11.28a18.37,18.37,0,0,0,22.45,17.91,7.11,7.11,0,0,0,2.42.43,7.47,7.47,0,0,0,7.25-7.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M158,135.28a3.3,3.3,0,1,0,3.3-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M170.59,135.28a3.3,3.3,0,1,0,3.3-3.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 156.99,
    y1: 131.97,
    x2: 146.49,
    y2: 131.97
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryGroup);
export default __webpack_public_path__ + "static/media/recovery_group.eb526b0555e8897ce1b132fe5ae7825d.svg";
export { ForwardRef as ReactComponent };